export default __webpack_public_path__ + "static/media/Vending1.def1d8ed.png";